module.exports = __webpack_public_path__ + "img/portrait_intro_blanc.2b9bccb7.png";